import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import moment from 'moment-mini';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GameService } from '../../../../shared/services/game/game.service';
import { GameDetails, GameMessageType, GameModalMessage, GamePoints, SweepstakesWinner, ProfileType } from '../../../../shared/constants/divisional.interface';
import { DAYS, MONTHS, YEARS, GAMETYPES, MINAGES } from '../../../../shared/constants/constants';
import {properties} from '../../../../../environments/properties';
import { ToasterService } from '../../../../shared/components/toaster/toaster/toaster.service';
import { ToasterType } from '../../../../shared/components/toaster/toaster/toaster.interface';
import { AuthService } from 'src/app/shared/services/auth.service';

// Import jQuery
declare let $: any;
@Component({
    selector: 'app-opt-in',
    templateUrl: './opt-in.component.html'
})
export class OptInComponent implements OnInit {

    public numberOfDays = 31;
    public buttonText: string = 'optIn btn';
    public disableGamePlay: boolean = false;
    public programRulesLink: string = '';
    public programGameLink: string = '';
    public banner = '';
    public storeId = '';
    public gameType: string = '';
    public programMinAge: number = 0;
    public errorMessageText: string = '';
    public phoneNum = false;
    public programName: string = '';
    public showComponent: boolean = false;
    public profileData: ProfileType = { firstName: '', lastName: '', email: '', optin: false, subscriptionValue: '', effectiveTimePeriods: {}, profileErrorMsg: '', phones:[] };
    public optInStatus: boolean = false;
    public optInChkbox: boolean = false;
    public user = { firstName: '', lastName: '', email: '', phoneNumber: '',  tncCheckbox: false, month: 'Month', day : 'Day', year: 'Year' };

    
    public months: Array<string> = MONTHS;
    public days: Array<string> = DAYS(this.numberOfDays);
    public years = YEARS(100);
    
    public selectedMonth = 'Month';
    public selectedMonthNum = 0; 
    public selectedYear = 'Year'; 
    public selectedDay = 'Day'; 
    public leapYear = false;
    public disableStartPlaying: boolean = false;
    public tokenLabelSingular: string = '';
    public tokenLabelPlural: string = '';
    public gameModalMessageObserver: any = null;
    public optInFromPrizeData: any = null;

    //SPA changes
    @Input() programId: string;
    @Input() userInfo: any;
    @Input() singleCard: boolean = false;
    @Input() forceHideButtion: boolean = false;
    
    
    @ViewChild('optInBtn') optInBtnEle: ElementRef;
    @ViewChild( 'optInModal', { read: TemplateRef }) optInModal: TemplateRef<any>;
    public optInModalRef: BsModalRef = null;

    @ViewChild('cantPlayPopup', { read: TemplateRef }) cantPlayPopup: TemplateRef<any>;
    public cantPlayPopupRef: BsModalRef = null;

    @ViewChild('errorPopup', { read: TemplateRef }) errorPopup: TemplateRef<any>;
    public errorPopupRef: BsModalRef = null;

    constructor(private elementRef: ElementRef, private authService: AuthService, public gameService: GameService, public modalService: BsModalService, public toasterService:ToasterService) {
        this.errorMessageText = properties.gameNotAvailable;
    }

    ngOnInit(): void {
        this.banner = this.userInfo.banner;
        this.storeId = this.userInfo.j4uStoreId;

        this.gameModalMessageObserver = this.gameService.gameModalMessageObservable.subscribe(message => {
            // update fields based on message
            if (message.mode == GameMessageType.SHOWOPTIN) {
                this.openOptInPop();
            }
            if(message.mode == GameMessageType.SHOWOPTINFROMPRIZE) {
                this.optInFromPrizeData = message;
                this.optinPopupFromPrize();
            }
        });
      
        this.gameService.refreshGameDetailsObservable.subscribe(details => {
            // Game is loaded
            // console.warn("refreshing opt-in for:" + JSON.stringify(details));
            if (details.codes == this.programId) {
                this.programName = details.names;
                this.optInStatus = details.userOptedIn;
                this.gameType = details.type ? details.type.toUpperCase() : '';
                this.programGameLink = details.gameLink;
                this.programRulesLink = details.rulesLink;
                this.tokenLabelSingular = details.tokenLabelSingular;
                this.tokenLabelPlural = details.tokenLabelPlural;
                this.programMinAge = details.programMinAge;
                this.disableGamePlay = details.disableGamePlay;
                if(!this.disableGamePlay) {
                    this.updateButtonText(this.optInStatus);
                }
                this.showComponent = true;
                if(this.gameService.isAuthenticated(this.userInfo) && !this.optInStatus) {
                    
                    //**  Need to update the service accordingly
                    this.gameService.getCustomerProfileDetails(this.programId, this.userInfo).subscribe((pData) => {
                        this.profileData = pData;
                        if(!this.disableGamePlay) {
                            this.updateButtonText(this.optInStatus);
                            this.populateOptInForm();
                        }
                    });
                }

            }

            // Note: may not want to refresh the entire prize grid each time an item is redeemed, may have to have a separate event
        });


    }

    public populateOptInForm () {
        this.user.firstName = this.profileData.firstName;
        this.user.lastName = this.profileData.lastName;
        this.user.email = this.profileData.email;
        if(this.profileData.phones && this.profileData.phones.length > 0) {
            this.phoneNum = true;
            this.user.phoneNumber = this.profileData.phones[0].number;
        }
        this.user.tncCheckbox= false;
        this.user.month = 'Month';
        this.user.day = 'Day';
        this.user.year = 'Year';
    }
    
    public updateButtonText(optInStatus: boolean) {
        let text: string = '';
        if(this.gameType == GAMETYPES.EPISODIC) {
            text = optInStatus ? `Play ${this.programName}` : 'Start Playing'; 
        } else if(this.gameType == GAMETYPES.DIVISION) {
            if(this.gameService.optinEnhancements) {
                text = 'Shop to earn {tokenLabel}';
                text = text.replace(/{tokenLabel}/g, this.tokenLabelPlural);
            } else {
                text = 'Shop to earn {tokenLabel}';
                text = optInStatus ? text.replace(/{tokenLabel}/g, this.tokenLabelPlural) : 'Start Playing';
            }
        }

        text = text.replace(/{gameName}/g, this.programName);
        this.buttonText = text;
    }

    public getChannelValue(): string {
        let channel = 'instore';
        let cookie = {};
        try {
            cookie = JSON.parse(window['AB'].COMMON.getCookie('SWY_SYND_USER_INFO'));
        } catch (e) {
            // catch parsing error if any
        }
        if (cookie['preference'] && cookie['preference'].toLowerCase() === 'Delivery'.toLowerCase()) {
            channel = 'delivery';
        }
        if (cookie['preference'] && cookie['preference'].toLowerCase() === 'Dug'.toLowerCase()) {
            channel = 'dug';
        }
        return channel;
    }

    public optinPopupFromPrize() {
        this.populateOptInForm();
        if (this.gameService.isAuthenticated(this.userInfo)) {
            this.modalService.onShown.subscribe(() => {
                window['AB'].DIVISIONAL.modalTrapKeyboard(".optin-modal-dialog");
            });
            this.optInModalRef = this.modalService.show(this.optInModal, { class: 'episodic-modal-dialog optin-modal-dialog'});
            this.analyticsModalTracking('almost-there|view', 'view');
            // console.warn(this.optInModalRef , 'this.optInModalRef');
        } else {
            this.analyticsUpdateTopNav();
            if (!this.authService.isUserLoggedIn(this.userInfo)) {
                this.authService.redirectToSSO(this.userInfo);
            }
        }
        let button = document.getElementById("optInClose");
        if (this.optInModalRef && button) {
            button.focus();
        }
    }

    public openOptInPop() {
        let gameLink = '';
        if ((this.optInStatus || this.gameService.optinEnhancements) && this.gameType == GAMETYPES.DIVISION) {
            this.analyticsUpdateTopNav();
            gameLink = this.programGameLink.replace(/{banner}/g, this.banner);
            window.location.href = gameLink;
        } else if(this.optInStatus && this.gameType == GAMETYPES.EPISODIC) {
            gameLink = this.programGameLink.replace(/{banner}/g, this.banner);
            gameLink = gameLink + '?mobile=false&storeID=' + this.storeId 
                + '&banner=' + this.banner 
                + '&channel=' + this.getChannelValue()
                + '&gameHome=' + encodeURIComponent(window.location.origin + window.location.pathname);
            window.location.href = gameLink;
        } else {
            this.populateOptInForm();
            if (this.gameService.isAuthenticated(this.userInfo)) {
                this.modalService.onShown.subscribe(() => {
                    window['AB'].DIVISIONAL.modalTrapKeyboard(".optin-modal-dialog");
                });
                this.optInModalRef = this.modalService.show(this.optInModal, { class: 'episodic-modal-dialog optin-modal-dialog'});
                this.analyticsModalTracking('almost-there|view', 'view');
                // console.warn(this.optInModalRef , 'this.optInModalRef');
            } else {
                this.analyticsUpdateTopNav();
                if (!this.authService.isUserLoggedIn(this.userInfo)) {
                     this.authService.redirectToSSO(this.userInfo);
                }
            }
            let button = document.getElementById("optInClose");
            if (this.optInModalRef && button) {
                button.focus();
            }
        }
    }

    

    public closeModal(optIn) {
        optIn.reset(this.user);
        this.optInModalRef.hide();
        if(this.optInFromPrizeData && this.gameService.optinEnhancements) {
            this.optInFromPrizeData.elementEvent.target.focus(); 
        } else {
            this.optInBtnEle.nativeElement.focus();
        }
        this.analyticsModalTracking('almost-there|close', 'click');
    }

    public optInGameHandler(): void {
        this.disableStartPlaying = true;
        let requestBody : any = {};
        requestBody.enrollments = [{
            program: this.programId,
            status: 'ACTIVE'
        }];
        
        // Let customer enter new values only if profile does not have first name or last name. If profile name exists, use the same 
        if(!this.profileData.firstName.length && this.user.firstName && this.user.firstName.length > 0) {
            requestBody.firstName = this.user.firstName;
        } else {
            requestBody.firstName = this.profileData.firstName;
        }
    
        if(!this.profileData.lastName.length && this.user.lastName && this.user.lastName.length > 0) {
            requestBody.lastName = this.user.lastName;
        } else {
            requestBody.lastName = this.profileData.lastName;
        }

        if(this.profileData.email.length == 0) {
            requestBody.email = this.user.email;
        }

        if(!this.phoneNum) {
            this.user.phoneNumber = this.user.phoneNumber.split('.').join('');
            requestBody.phone =  { number : this.user.phoneNumber, "purpose": "PRIMARY"};
        }
        requestBody.storeId = this.userInfo.j4uStoreId || this.storeId;


        // new field with dd/mm/yyyy format
        const dateOfBirth = new Date(`${this.selectedYear}/${this.selectedMonthNum}/${this.selectedDay}`);
        requestBody.dateOfBirth = moment(dateOfBirth).format('MM/DD/YYYY');
        let today = moment();
        
        if ( today.diff(requestBody.dateOfBirth, "years") < this.programMinAge ) {
            this.disableStartPlaying = false;
            this.optInModalRef.hide();
            this.cantPlayPopupRef = this.modalService.show(this.cantPlayPopup, { class: 'episodic-modal-dialog'});
            this.analyticsModalTracking('we-are-sorry|view', 'view');
            return;
        }

        this.gameService.saveOptinWithEarnGamePlay(requestBody, this.userInfo).subscribe((res) => {
            if (res && res['status'] && res.status === 'Success') {
                this.disableStartPlaying = false;
                this.optInModalRef.hide();
                this.optInStatus = true;
                this.updateButtonText(true);
                this.toasterService.show({ title: 'OK', message: 'Thanks for linking your account', type: ToasterType.Success, autoCloseTime: 7000 }, { top: '20vh' });
                if (window['AB'] && window['AB'].DATALAYER) {
                    window['AB'].DATALAYER.setLinkClickEvents('toast-message|thanks-for-linking-your-account');
                }
                if(this.gameService.optinEnhancements && this.optInFromPrizeData) {
                    this.gameService.refreshOptInStatusOnly.next(this.optInFromPrizeData);
                } else {
                    this.gameService.refreshOptInStatus.next(true);
                }
            }
        }, err => {
            // console.warn(err, 'err in saveOptinWithEarnGamePlay API');
            this.disableStartPlaying = false;
            this.optInModalRef.hide();
            // 401: Invalid Auth */
            if (err == 'Invalid authorization') {
                if (!this.authService.isUserLoggedIn(this.userInfo)) {
                    this.authService.redirectToSSO(this.userInfo);
                }
            } else if(err.length && err[0].code == "OCGP_40204") {
                this.errorMessageText = err[0].message;
                this.cantPlayPopupRef = this.modalService.show(this.cantPlayPopup, { class: 'episodic-modal-dialog'});
            } else {
                this.errorPopupRef = this.modalService.show(this.errorPopup, { class: 'episodic-modal-dialog'});
            }
        });
    }

    numOfDays(selectedMonthNum, leapYear) {
        const oddMonths = [1, 3, 5, 7, 8, 10, 12];
        const evenMonths = [4, 6, 9, 11];

        if (selectedMonthNum == 2) {
          this.numberOfDays = leapYear ? 29 : 28;
          if(this.selectedDay != 'Day' && (Number(this.selectedDay) > this.numberOfDays)) {
            this.user.day = 'Day';
          }
        } else if (oddMonths.some(month => (month === selectedMonthNum))) {
          this.numberOfDays = 31;
        } else if (evenMonths.some(month => (month === selectedMonthNum))) {
          this.numberOfDays = 30;
        }
        this.days = Array.from({ length: this.numberOfDays }, (_, x) => (x + 1).toString());
      }

    public monthsHandler(month) {
        this.selectedMonthNum = this.months.indexOf(month) + 1;
        this.numOfDays(this.selectedMonthNum, this.leapYear);
    };
    
    public daysHandler(selectedDate) {
        this.selectedDay = selectedDate;
    };

    public yearHandler(selectedYear) {
        this.selectedYear = selectedYear;
        this.leapYear = moment([selectedYear]).isLeapYear();
        this.numOfDays(this.selectedMonthNum, this.leapYear);
    };

    public analyticsModalTracking(modalAction, event) {
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.setGamesModalEvents(this.programId, modalAction, event);
            if (modalAction === 'almost-there|view') {
                window['AB'].DATALAYER.gamesModalHandler(this.programId, 'almost-there|close');
            }
        }
    }
    
    public analyticsUpdateTopNav() {
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.setTopNavPreviousPage();
        }
    }

    ngOnDestroy() {
        this.gameModalMessageObserver && this.gameModalMessageObserver.unsubscribe();
    }
}
